import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { CdxApiGatewayHttpService } from '../../shared/services/cdx-api-gateway-http.service';
import { Endpoints } from './endpoints';

@Injectable({
  providedIn: 'root',
})
export class HealthCheckService {
  private http = inject(CdxApiGatewayHttpService);

  public callHealthCheck(): Observable<any> {
    return this.http.post(Endpoints.HEALTH_CHECK, JSON.stringify({}));
  }
}
